import { LoadingCard } from "@/components/ui/loading-card";

interface MsalLoadingStateProps {
  message?: string;
  className?: string;
}

export function MsalLoadingState({
  message,
  className
}: MsalLoadingStateProps) {
  return (
    <LoadingCard
      text={message}
      spinnerSize="lg"
      showThemeToggle={true}
      className={className}
    />
  );
}
